const rankingData = [
  { rank: 1, title: '流浪地球3', type: '科幻大片', hot: '980万热度', tag: '新上线' },
  { rank: 2, title: '长安十二时辰', type: '古装悬疑', hot: '856万热度', tag: '热播中' },
  { rank: 3, title: '乘风破浪的姐姐', type: '热门综艺', hot: '742万热度', tag: '更新中' },
  { rank: 4, title: '名侦探柯南', type: '经典动漫', hot: '689万热度', tag: '连载中' },
  { rank: 5, title: '繁花', type: '都市情感', hot: '621万热度', tag: '高分' },
  { rank: 6, title: '大江大河3', type: '年代剧', hot: '558万热度', tag: '推荐' },
  { rank: 7, title: '地球脉动3', type: '纪录片', hot: '492万热度', tag: '4K' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门榜单</h2>
            <p className="mt-3 text-sm text-foreground-500">全网热播影视 · 实时热度排名</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="lg:col-span-2 lg:row-span-4">
              <div className="bg-background-100 rounded-2xl p-5 md:p-6 h-full">
                <div className="flex items-center gap-2 mb-5">
                  <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                    <i className="ri-fire-fill text-background-50 text-sm"></i>
                  </div>
                  <span className="font-heading text-lg font-bold text-foreground-900">热播总榜 TOP 3</span>
                </div>
                <div className="space-y-4">
                  {rankingData.slice(0, 3).map((item) => (
                    <div key={item.rank} className="flex items-center gap-4 p-3 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer">
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-bold ${
                        item.rank === 1 ? 'bg-primary-500 text-background-50' :
                        item.rank === 2 ? 'bg-accent-500 text-background-50' :
                        'bg-secondary-500 text-background-50'
                      }`}>
                        {item.rank}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                          <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">{item.tag}</span>
                        </div>
                        <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
                      </div>
                      <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.hot}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {rankingData.slice(3).map((item) => (
              <div key={item.rank} className="bg-background-100 rounded-2xl p-5 hover:bg-background-200/50 transition-colors cursor-pointer">
                <div className="flex items-center justify-between mb-3">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm font-bold ${
                    item.rank <= 5 ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.rank}
                  </div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{item.type}</p>
                <div className="flex items-center gap-1 mt-2 text-xs text-accent-600">
                  <i className="ri-fire-line"></i>
                  <span>{item.hot}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}